module.exports = __webpack_public_path__ + "static/media/placeholder.118bd693.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Blog/placeholder.svg
// module id = 1107
// module chunks = 0